var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.374312 0.219967C0.678942 -0.024398 1.09795 -0.0690685 1.44725 0.105582L21.4473 10.1056C21.786 10.275 22 10.6212 22 11C22 11.3788 21.786 11.725 21.4473 11.8944L1.44725 21.8944C1.09795 22.0691 0.678942 22.0244 0.374312 21.7801C0.0696828 21.5357 -0.0648202 21.1363 0.0298972 20.7575L2.46926 11L0.0298972 1.24254C-0.0648202 0.863675 0.0696828 0.464332 0.374312 0.219967ZM4.28082 12L2.49751 19.1332L16.764 12H4.28082ZM16.764 10H4.28082L2.49751 2.86678L16.764 10Z",
    fill: "#196CA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.18f0d060fabc712a38e07d544f91c4d3.svg";
export { ForwardRef as ReactComponent };